import React from 'react';
import { Select, Input } from 'antd';
import TextEvents from 'app/components/TextEvents';
import { styles, useStyles } from './TextInputStyles';
import { Grid } from '@material-ui/core';

export default function TextInput(props) {

    let classes = useStyles();
    return (
        <div style={props.isFlex ? { display: 'flex', alignItems: 'center' } : { display: 'unset' }}>
            <Grid container>
                <Grid item >
                    <TextEvents
                        text={props.text}
                        color={props.color}
                        size={props.size}
                        weight={props.weight}
                        paddingB={props.paddingBottom}
                        labelWidth={props.labelWidth}
                    />
                </Grid>
                <Grid item>
                    <TextEvents
                        text={props.tamano}
                        color={props.tcolor}
                        size="5px"
                        display="float"
                        style="text-align: right !important"
                    />
                </Grid>
            </Grid>

            {props.mode === 'input' ?
                <div style={props.withPadding === true ? { paddingRight: '8px' } : { paddingRight: 0 }}>
                    <Input
                        maxLength={props.maxLength == undefined ? 1000 : props.maxLength}
                        type={props.type === 'number' ? 'number' : 'text'}
                        disabled={props.disabled}
                        value={props.value}
                        placeholder={props.placeholder}
                        style={styles.inputSelect}
                        className={classes.inputSelect}
                        allowClear={props.allowClear}
                        onChange={
                            (e) => props.setValue(e.target.value)
                        }
                        onKeyUp={props.KeyUp == undefined ? null : (e) => {
                            props.KeyUp(e)
                        }}
                    />


                </div>
                : <Select
                    showSearch={props.showSearch ? true : false}
                    optionFilterProp="children"
                    disabled={props.disabled}
                    showArrow={props.showArrow}
                    mode={props.mode}
                    placeholder={props.placeholder}
                    style={props.style ? props.style : styles.inputSelect}
                    defaultValue={props.defaultValue}
                    allowClear={props.allowClear}
                    onChange={(v) => props.onChange(v)}
                >
                    {props.children}
                </Select>
            }
        </div>
    );
}